export class NumericUtilities {
    public static ParseNumber(numberToParse:any,defaultValue:any=0)
    {
        if(numberToParse==null)
            return defaultValue;

        numberToParse=parseFloat(numberToParse.toString());
        if(isNaN(numberToParse))
            return defaultValue;
        return numberToParse;
    }


}